import { useSelector } from "react-redux";
import HorizantalBar from "../../../components/horizantalBar/HorizantalBar";
import PageLink from "../../../components/pageLink/PageLink";
import { allowedTabs } from "../../../constants/permissionCatalog";
import LogsNavigator from "../../../navigation/LogsNavigator";
import styles from "./logs.module.css";

const Logs = () => {
  const { rolePermissions } = useSelector((state) => state.user);
  const tabs = allowedTabs("logs", rolePermissions);

  return (
    <div className={styles.container}>
      <HorizantalBar>
        <div className={styles.linksWrapper}>
          {tabs.map((tab) => (
            <div key={tab.id} className={styles.linkWrapper}>
              <PageLink destination={`/dashboard/logs/${tab.path}`}>{tab.label}</PageLink>
            </div>
          ))}
        </div>
      </HorizantalBar>
      <LogsNavigator />
    </div>
  );
};

export default Logs;
